<template lang="html">
  <div :class="content.type">
    <div class="actions">
      <div class="slidecontainer">
        <input type="range" min="1" :max="content.options.length" class="slider" ref="rangeSlider" value="1" @change="slideClass">

        <div class="slide-keys" >
          <div class="slide-key-wrap" v-for="(c, i) in content.options" :key="i" >
            <div class="slide-key">
              {{ c.label }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <button v-if="!chosen" disabled class="btn btn-outline-light btn-lg remix-next">Next</button> -->
    <template v-for="(t, i) in targets">
      <!-- <router-link v-if="target == t" :to="{ name: 'questions', params: {from: slug, q: getQ(t)} }" class="btn btn-outline-light btn-lg remix-next" :class="buttonAble(abled)">Next</router-link> -->
      <router-link :to="{ name: 'questions', params: {from: slug, q: getQ(t)} }" class="btn btn-outline-light btn-lg remix-next" :class="buttonAble(abled)" :key="'tar'+i">Next</router-link>
    </template>
  </div>
</template>

<script>
export default {
  props: [
    'content',
    'slug'
  ],
  data() {
    return {
      chosen: false,
      formValue: false,
      target: false,
      formKey: false,
      abled: true
    }
  },
  methods: {
    buttonAble(abled) {
      return abled ? "" : "disabled";
    },
    getQ(slug) {
      return this.$store.state.content[slug].id;
    },
    setFormVal(payload){
      this.$store.commit('setFormData',payload);
    },
    slideClass(event) {
      this.chosen = true;
      this.chosen = event ? event.target.value : this.$refs.rangeSlider.value;
      this.formValue = this.content.options[this.chosen - 1].value;
      this.target = this.content.options[this.chosen - 1].target;
      this.formKey = this.content.prop;
      this.abled = true;
      this.setFormVal({prop: this.formKey, value: this.formValue, group: this.content.group, report: this.totalScore, score: this.content.options[this.chosen - 1].score, serial: this.content.options[this.chosen - 1].serial, id: parseInt(this.$router.currentRoute.params.q)});
      this.$store.commit('setNext',this.nextQ);
    }
  },
  computed: {
    totalScore() {
      // for max val
      let type = this.content.type;
      let scores = [];
      this.content.options.forEach((v)=>{
        let score = v.score ? v.score : 0;
        scores.push(score);
      });
      return (Math.max.apply(null, scores) > 0) ? Math.max.apply(null, scores) : false;
    },
    nextQ() {
      let con = this.content;
      return this.chosen ? this.getQ(con.options[this.chosen - 1].target) : this.getQ(con.options[0].target);
    },
    targets() {
      let opt = this.content.options;
      let tar = [];
      opt.forEach( function(v) {
        tar.push(v.target);
      });
      // console.log(tar);
      return Array.from(new Set(tar));
    },
    // selVal() {
    //   return this.chosen ? document.querySelector('.slidecontainer input').value : 1;
    // }
  },
  mounted() {
    // const element = document.querySelector('.slidecontainer input');
    // console.log('mounted');
    this.slideClass();
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/vars';
@import '../../assets/scss/mixins';

.actions {
  min-width: 16rem;
  margin-bottom: gu(1.5);

  @media only screen and (min-width: 40rem) {
    min-width: rem-calc(550);
  }
}

.slidecontainer {
  width: 100%;

  .slider {
    -webkit-appearance: none;  /* Override default CSS styles */
    appearance: none;
    width: 100%; /* Full-width */
    height: rem-calc(1); /* Specified height */
    background: $white; /* Grey background */
    outline: none; /* Remove outline */
    opacity: 0.7; /* Set transparency (for mouse-over effects on hover) */
    -webkit-transition: opacity .2s; /* 0.2 seconds transition on hover */
    transition: opacity .2s;
    margin: auto;

    /* Mouse-over effects */
    &:hover {
      opacity: 1; /* Fully shown on mouse-over */
    }

    /* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */ 
    &::-webkit-slider-thumb {
      -webkit-appearance: none; /* Override default look */
      appearance: none;
      position: relative;
      bottom: rem-calc(12);
      width: rem-calc(48); /* Set a specific slider handle width */
      height: rem-calc(24); /* Slider handle height */
      border: solid;
      border-color: $colTeal transparent transparent;
      border-width: rem-calc(24) rem-calc(24) 0;
      // background: $colTeal; /* Green background */
      cursor: pointer; /* Cursor on hover */
    }

    &::-moz-range-thumb {
      width: 25px; /* Set a specific slider handle width */
      height: 25px; /* Slider handle height */
      background: #4CAF50; /* Green background */
      cursor: pointer; /* Cursor on hover */
    }
  }
  
  .slide-keys {
    // width: 95%;
    display: flex;
    justify-content: space-between;
    margin-left: 24px;
    margin-right: 24px;

    @media only screen and (min-width: 40rem) {
      // width: calc(100% - 48px);
    }
  }

  .slide-key-wrap {
    position: relative;
    width: rem-calc(1);
    font-size: rem-calc(25);
    height: 1em;

    @media only screen and (min-width: 40rem) {
      font-size: rem-calc(35);
    }
  }

  .slide-key {
    position: absolute;
    // flex: 0 0 33%;
    transform: translateX(-50%);
    font-size: inherit;
    font-weight: $fwLight;
    // width: rem-calc(48);
    white-space: nowrap; 
    // text-align: center;
  }
}
</style>
